import { gql } from "@apollo/client";

export const QUERY_FORMTAMES4_VERSION = gql`
  query studentFormTames4(
    $studentFormId: ID!
    $formId: ID!
    $studentId: ID!
    $schoolId: ID!
    $studentMeetingId: ID!
  ) {
    studentFormTames4(
      studentFormId: $studentFormId
      studentId: $studentId
      formId: $formId
      schoolId: $schoolId
      studentMeetingId: $studentMeetingId
    ) {
      versionId
      formId
      formDate
      studentDob
      studentFullName
      determinationSpecificLearningDisability
      intellectualGeneralIntelligence
      adaptiveBehavior
      normTest
      criterionTest
      portfolio
      observations
      interview
      hearingScreeningConductedBy
      other
      descriptiveAnalysis
      intellectualCriteria
      determinantEnvironmentalCultural
      formAction
      formStatus
    }
  }
`;
